import * as React from 'react';
import {Modal, ModalProps} from 'react-bootstrap';
import './Modal.css';

interface ModalContentProps extends ModalProps {
    title: string;
    content: string;
    complexContent?: any;
    footer?: any;
    additional?: any;
    topic?: string;
    activeColor?: string;
    customContentColor?: string;
    checkmarkUrl?: string;
    checkMarkRedUrl?: string;
}

export class PonderaModal extends React.Component<ModalContentProps> {
    constructor(props: ModalContentProps) {
        super(props);
    }

    render() {
        let title = (
            <div className="pva-style-modal-title">
                <div className="header">
                    <div className="text">
                        <div className="topic font-subheading">{this.props.topic || ""}</div>
                        <div className="title font-heading">{this.props.title || ""}</div>
                    </div>
                </div>
                <div className="modal-closer" onClick={this.props.onHide as any}>
                    <img src="/images/close x.svg" />
                    <span className="modal-close-button font-heading">Close</span>
                </div>
            </div>
        );
        
        if (!this.props.show) return <div style={{display:'none'}}></div>;
        
        return <Modal 
                className="component-PonderaModal style-modal" 
                show={this.props.show} 
                onHide={this.props.onHide}
                style={{
                    '--active-tab-color': this.props.activeColor,
                    '--custom-content-color': this.props.customContentColor,
                    '--checkmark-url': this.props.checkmarkUrl,
                    '--check-mark-url': this.props.checkMarkRedUrl
                } as any}
            >
                <Modal.Header>{title}</Modal.Header>
                <Modal.Body>
                    <div dangerouslySetInnerHTML={{__html: this.props.content}}/>
                    {this.props.complexContent}
                </Modal.Body>
                {this.props.footer &&
                    <Modal.Footer>
                        <div className="modal-footer">
                            {this.props.footer}
                            {this.props.additional}
                        </div>
                    </Modal.Footer>
                }
            </Modal>;
    }
}


// WEBPACK FOOTER //
// ./src/components/inclinationmodals/PonderaModal.tsx